import {CustomCssVarsFn} from '@wix/yoshi-flow-editor'

import {
  formBoxStylesParams,
  FormBoxStylesParams,
  formLineStylesParams,
  FormLineStylesParams,
} from '../../components-shared/Settings/FormDesign/stylesParams'
import {
  imageStylesParams,
  ImageStylesParams,
} from '../../components-shared/Settings/Image/stylesParams'
import {
  timeSlotsDefaultStylesParams,
  timeSlotsSelectedStylesParams,
  timeSlotsClosedStylesParams,
  TimeSlotsDefaultStylesParams,
  TimeSlotsSelectedStylesParams,
  TimeSlotsClosedStylesParams,
} from '../../components-shared/Settings/TimeSlots/stylesParams'
import {
  AlignmentToAlignItems,
  AlignmentToTextAlign,
  DirectionToFlexDirection,
  ImageSizeToBackgroundSize,
} from '../../types/createStylesParams'

import {
  BackgroundAndBordersStylesParams,
  backgroundAndBordersStylesParams,
} from './Settings/Tabs/Design/BackgroundAndBorders/stylesParams'
import {
  commonButtonStylesParams,
  CommonButtonStylesParams,
  formButtonStylesParams,
  FormButtonStylesParams,
  headerButtonStylesParams,
  HeaderButtonStylesParams,
} from './Settings/Tabs/Design/Buttons/stylesParams'
import {generalStylesParams, GeneralStylesParams} from './Settings/Tabs/Design/General/stylesParams'
import {textStylesParams, TextStylesParams} from './Settings/Tabs/Design/Text/stylesParams'
import {
  headerLayoutStylesParams,
  HeaderLayoutStylesParams,
} from './Settings/Tabs/Layout/Header/stylesParams'
import {
  aboutSectionStylesParams,
  AboutSectionStylesParams,
} from './Settings/Tabs/Layout/AboutSection/stylesParams'
import {
  reservationFormStylesParams,
  ReservationFormStylesParams,
} from './Settings/Tabs/Layout/ReservationForm/stylesParams'

export type IStylesParams = TimeSlotsDefaultStylesParams &
  TimeSlotsSelectedStylesParams &
  TimeSlotsClosedStylesParams &
  TextStylesParams &
  ImageStylesParams &
  CommonButtonStylesParams &
  HeaderButtonStylesParams &
  FormButtonStylesParams &
  FormBoxStylesParams &
  FormLineStylesParams &
  BackgroundAndBordersStylesParams &
  HeaderLayoutStylesParams &
  AboutSectionStylesParams &
  ReservationFormStylesParams &
  GeneralStylesParams

export const stylesParams = {
  ...timeSlotsDefaultStylesParams,
  ...timeSlotsSelectedStylesParams,
  ...timeSlotsClosedStylesParams,
  ...textStylesParams,
  ...imageStylesParams,
  ...commonButtonStylesParams,
  ...headerButtonStylesParams,
  ...formButtonStylesParams,
  ...formBoxStylesParams,
  ...formLineStylesParams,
  ...backgroundAndBordersStylesParams,
  ...headerLayoutStylesParams,
  ...aboutSectionStylesParams,
  ...reservationFormStylesParams,
  ...generalStylesParams,
}

export default stylesParams

export const customCssVars: CustomCssVarsFn = ({styleParams}) => {
  const numbers = styleParams.numbers

  return {
    breadcrumbsAlignment: AlignmentToTextAlign[numbers.breadcrumbsAlignment],
    titleAndSubtitleAlignment: AlignmentToTextAlign[numbers.titleAndSubtitleAlignment],
    detailsBoxAlignment: AlignmentToAlignItems[numbers.detailsBoxAlignment],
    detailsBoxCellStretch: numbers.detailsBoxCellStretch ? 'unset' : '50%',
    detailsBoxTextAlignment: AlignmentToTextAlign[numbers.detailsBoxTextAlignment],
    headerButtonAlignment: AlignmentToAlignItems[numbers.headerButtonAlignment],
    imageAlignment: DirectionToFlexDirection[numbers.imageAlignment],
    imageSize: ImageSizeToBackgroundSize[numbers.imageSize],
    aboutSectionAlignment: AlignmentToTextAlign[numbers.aboutSectionAlignment],
    reservationFormTitleAlignment: AlignmentToTextAlign[numbers.reservationFormTitleAlignment],
    reservationFormAlignment: AlignmentToAlignItems[numbers.reservationFormAlignment],
    reservationFormButtonAlignment: AlignmentToAlignItems[numbers.reservationFormButtonAlignment],
  }
}
